(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cb-v2-text-anim"] && !Shopify.designMode) return;
  try {
    (function () {
  function observe(els) {
    var groups = {};
    els.forEach(function (el) {
      var sec = el.closest('[data-anim-offset]');
      var key = sec ? (sec.getAttribute('data-anim-offset') || '20') : '20';
      if (!groups[key]) groups[key] = [];
      groups[key].push(el);
    });
    Object.keys(groups).forEach(function (key) {
      var px = parseInt(key, 10) || 20;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('cb-anim--in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -' + px + 'px 0px' });
      groups[key].forEach(function (el) { io.observe(el); });
    });
  }

  function initAnim(scope) {
    var els = Array.prototype.slice.call((scope || document).querySelectorAll('[data-cb-anim]'));
    if (!els.length) return;
    observe(els);
  }

  function replayAnim(scope) {
    var els = Array.prototype.slice.call(scope.querySelectorAll('[data-cb-anim]'));
    if (!els.length) return;
    // Instantly snap to invisible without playing reverse transition
    els.forEach(function (el) {
      el.style.transition = 'none';
      el.classList.remove('cb-anim--in');
    });
    // Force a paint so browser renders the invisible state
    scope.getBoundingClientRect();
    // Restore transitions and start animating after a brief pause
    setTimeout(function () {
      els.forEach(function (el) { el.style.transition = ''; });
      observe(els);
    }, 400);
  }

  document.addEventListener('shopify:section:load', function (e) {
    replayAnim(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAnim(); });
  } else {
    initAnim();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
